<app-progress-spinner [show]="isLoading"></app-progress-spinner>

@if (!isLoading) {
  <div class="control-info-container">
    <div class="control-details">
      <div class="form-row">
        <label for="controlName">{{ 'Name' | translate }}:</label>
        <input id="controlName" type="text" [value]="controlDetails?.name || '-'" disabled />
      </div>
      <div class="form-row">
        <label for="controlCode">{{ 'Code' | translate }}:</label>
        <input id="controlCode" type="text" [value]="controlDetails?.code || '-'" disabled />
      </div>
      <div class="form-row">
        <label for="controlType">{{ 'Type' | translate }}:</label>
        <input id="controlType" type="text" [value]="controlTypeName" disabled />
      </div>
      <div class="form-row">
        <label for="controlOwner">{{ 'Owner Name' | translate }}:</label>
        <input id="controlOwner" type="text" [value]="controlDetails?.ownerName || '-'" disabled />
      </div>
    </div>
    <div class="action-buttons">
      <button class="btn" (click)="openControlOrgLevelSegDialog()">{{ 'Add' | translate }}</button>
    </div>
  </div>
  <div class="custom-theme-table">
    <div class="custom-scrollbar table-responsive outer-bordered-table">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
            {{ 'No data matching the filter' | translate }}
          </td>
        </tr>
        <ng-container matColumnDef="segId">
          <th mat-header-cell *matHeaderCellDef>{{ 'SEG' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.segName || '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="organizationLevelId">
          <th mat-header-cell *matHeaderCellDef>{{ 'Organization Level' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.organizationLevelName || '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="ownerName">
          <th mat-header-cell *matHeaderCellDef>{{ 'Owner Name' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.ownerName || '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ 'Status' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <mat-select [value]="element.status" (selectionChange)="onStatusChange(element, $event.value)"
              class="status-select" [ngClass]="element.statusCssClass">
              @for (status of statusOptions; track trackById($index, status)) {
                <mat-option [value]="status.id">
                  {{ status.name | translate }}
                </mat-option>
              }
            </mat-select>
          </td>
        </ng-container>
        <ng-container matColumnDef="targetImplementationStart">
          <th mat-header-cell *matHeaderCellDef>{{ 'Target Start' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.targetStartFormatted }}</td>
        </ng-container>
        <ng-container matColumnDef="targetImplementationEnd">
          <th mat-header-cell *matHeaderCellDef>{{ 'Target End' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.targetEndFormatted }}</td>
        </ng-container>
        <ng-container matColumnDef="dateImplementationStart">
          <th mat-header-cell *matHeaderCellDef>{{ 'Implementation Start Date' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.implStartFormatted }}</td>
        </ng-container>
        <ng-container matColumnDef="dateImplementationComplete">
          <th mat-header-cell *matHeaderCellDef>{{ 'Implementation Complete Date' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.implCompleteFormatted }}</td>
        </ng-container>
        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef>{{ 'Notes' | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.notes || '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{'Actions' | translate}}</th>
          <td mat-cell *matCellDef="let element" class="text-align-right">
            <span class="material-icons edit cursor-pointer material-grey-icon"
            (click)="openControlOrgLevelSegDialog(element.id)">edit</span>
            <span class="material-icons delete cursor-pointer material-grey-icon"
            (click)="openControlOrgLevelSegDeleteDialog(element.id)">delete</span>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [class.even-row]="even">
        </tr>
      </table>
    </div>
    <div class="paginator-container">
      <span>{{ 'Displaying' | translate }}</span>
      <mat-paginator [length]="totalRecords" [pageSizeOptions]="[5, 10, 20, 50]" [pageSize]="10"></mat-paginator>
    </div>
  </div>
}